export const CREATE_PAYMENT_PLAN_TEMPLATE_MUTATION = `
  mutation CreatePaymentPlanTemplate($template: payment_plan_templates_insert_input!) {
    insert_payment_plan_templates_one(object: $template) {
      id
      template_name
      description
      year
      payment_schedule
      company_id
      status
      created_at
    }
  }
`;

export const UPDATE_PAYMENT_PLAN_TEMPLATE_MUTATION = `
  mutation UpdatePaymentPlanTemplate($id: Int!, $_set: payment_plan_templates_set_input!) {
    update_payment_plan_templates_by_pk(pk_columns: { id: $id }, _set: $_set) {
      id
      template_name
      description
      year
      payment_schedule
      company_id
      status
      created_at
    }
  }
`;

export const DELETE_PAYMENT_PLAN_TEMPLATE_MUTATION = `
  mutation DeletePaymentPlanTemplate($id: Int!) {
    delete_payment_plan_templates_by_pk(id: $id) {
      id
    }
  }
`;
